import styles from "../../object-passport.module.css";

import { formateISODateToDateTime, getFullName } from "@/utils";

const Aside = ({
  objectName,
  objectType,
  createDate,
  author,
  navs,
  navClick,
}) => {
  return (
    <div className={`${styles.aside} not-print`}>
      <div className={styles.asideTitle}>Информация</div>
      <div className={styles.mainInfo}>
        <div>
          <div className={styles.infoTitle}>Паспорт объекта</div>
          <div className={styles.infoDescription}>{objectName}</div>
        </div>
        <div>
          <div className={styles.infoTitle}>Тип объекта</div>
          <div className={styles.infoDescription}>{objectType}</div>
        </div>
        <div>
          <div className={styles.infoTitle}>Дата создания паспорта:</div>
          <div className={styles.infoDescription}>
            {formateISODateToDateTime(createDate)}
          </div>
        </div>
        <div>
          <div className={styles.infoTitle}>Автор:</div>
          {author && (
            <div className={styles.infoDescription}>
              {getFullName(
                author.lastname,
                author.firstname,
                author.patronymic
              )}
            </div>
          )}
        </div>
      </div>

      <div className={styles.asideTitle}>Содержание</div>
      <div className={styles.asideMenu}>
        {navs.map((nav) => {
          return (
            <a
              key={nav.uuid}
              href={`#${nav.uuid}`}
              className={styles.asideMenuItem}
              onClick={(e) => {
                e.preventDefault();
                navClick(nav.uuid);
              }}
            >
              {nav.name}
            </a>
          );
        })}
      </div>
    </div>
  );
};
export default Aside;
